import { render, staticRenderFns } from "./ValuerSelection.vue?vue&type=template&id=a86cbff4"
import script from "./ValuerSelection.vue?vue&type=script&lang=js"
export * from "./ValuerSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports